var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.18 18.066H.82a.821.821 0 01-.82-.82V9.405a.492.492 0 11.984 0v7.677h18.033V9.405a.492.492 0 11.984 0v7.841a.821.821 0 01-.821.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.508 9.9a.492.492 0 01-.474-.361l-1.8-6.552H2.768l-1.8 6.552a.492.492 0 01-.948-.261l1.9-6.913a.492.492 0 01.474-.361h15.213a.491.491 0 01.474.361l1.9 6.913a.492.492 0 01-.344.6.483.483 0 01-.129.022z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.147a3.83 3.83 0 01-3.737-3.279H.492a.492.492 0 010-.984h6.23a.492.492 0 01.492.492 2.787 2.787 0 105.574 0 .492.492 0 01.492-.492h6.23a.492.492 0 010 .984h-5.772A3.83 3.83 0 0110 13.147z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/Inbox.85845b867d2b896911caaa6c97179cd2.svg";
export { ForwardRef as ReactComponent };